import React from 'react';
import ContentLoader from 'react-content-loader';
import { Box } from '@mui/material';

const ActivityLogSkeleton = () => (
  <Box sx={{ mb: 2 }}>
    <ContentLoader
      speed={2}
      width="100%"
      height={60}
      backgroundColor="#3D393B"
      foregroundColor="#4A494B"
    >
      {/* Avatar */}
      <circle cx="20" cy="20" r="16" />
      
      {/* Activity message */}
      <rect x="44" y="10" rx="4" ry="4" width="80%" height="12" />
      <rect x="44" y="30" rx="4" ry="4" width="50%" height="10" />
    </ContentLoader>
  </Box>
);

export default ActivityLogSkeleton;